import { useCallback, useEffect } from 'react';
import { BREAKPOINTS } from '../../constants';
import { useContextSelector } from '../useContextSelector';

export const useIsMobile = () => {
  const { update } = useContextSelector();

  update.generics.isMobile(window?.innerWidth < BREAKPOINTS.mobile);

  const windowResize = useCallback(() => {
    update.generics.isMobile(window?.innerWidth < BREAKPOINTS.mobile);
  }, [update.generics.isMobile]);

  useEffect(() => {
    window.addEventListener('resize', windowResize);

    return () => window.removeEventListener('resize', windowResize);
  }, [windowResize]);
};
